import { useShimmer } from "../UseShimmer";
import { Bone } from "../ShimmerPrimitives";
import "./PatientDetailShimmer.css";


function FieldSkeleton() {
  return (
    <div className="pd-sh-field">
      <Bone w={80} h={10} r={4} />
      <Bone w="100%" h={38} r={6} />
    </div>
  );
}

function GridRow4({ mb }) {
  return (
    <div
      className="pd-sh-grid"
      style={mb != null ? { marginBottom: mb } : undefined}
    >
      <FieldSkeleton />
      <FieldSkeleton />
      <FieldSkeleton />
      <FieldSkeleton />
    </div>
  );
}

export default function PatientDetailShimmer() {
  useShimmer();

  return (
    <div className="pd-sh-root">
      <div className="pd-sh-photo-card">
        <Bone className="pd-sh-avatar" w={56} h={56} r="50%" />

        <div className="pd-sh-photo-info">

          {/* <Bone w={108} h={13} r={4} />

          <Bone w={140} h={10} r={4} /> */}

          <div className="pd-sh-photo-btns">
            {/* <Bone w={124} h={32} r={7} />
            <Bone w={112} h={32} r={7} /> */}
          </div>

          <div>
            {/* <Bone w={90} h={30} r={16} /> */}
          </div>
        </div>
      </div>

      <GridRow4 />

      <GridRow4 />

      <GridRow4 />

      <GridRow4 mb={6} />

    </div>
  );
}